import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import '../../../../libs/bulma.min.css';
import PbxContext from '../../../../context/PbxContext';
import { accessLocalStorage, valuesAnalyze, changeViewForms, exportSelectQueueMemberById, exportUpdateQueueMember, exportSelectAllQueues } from '../../../../services';
import Loading from '../../../Loading/LoadingModule';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave } from '@fortawesome/free-solid-svg-icons';

function MemberQueuesById() {
  const getItensStateGlobal = useContext(PbxContext);
  const { toggleIsHidden, itemsSelectedToEdit } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const [loading, setLoading] = useState(true);
  const [queues, setQueues] = useState([]);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const history = useHistory();

  const fetchMember = async () => {
    const membersList = await exportSelectQueueMemberById({ id: itemsSelectedToEdit });

    if(membersList.length <= 0) return history.push('/config/fila/membros/lista');
    if(membersList === undefined) setLoading(true);

    Object.keys(...membersList).forEach((item) => {
      if (item === 'queueName' || item === 'membername' || item === 'penalty' || item === 'paused') {
        membersList[0][item].length > 0 ? setValidate((prevState) => prevState, validate[item] = true) : null;
      }
    })

    const fetchQueues = await exportSelectAllQueues();
    if(fetchQueues.length <= 0) setQueues(['Necessário criar as filas primeiro']);
    const prepQueues = fetchQueues.map((element) => element.queuesselect);
    
    setQueues(prepQueues);
    setValues(...membersList);
    setLoading(false);
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = await accessLocalStorage.getUserLocalStorage();
    const { user: { role } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');

    const elements = await fetchMember();
    return;
  }, []);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, isTripleChar } = valuesAnalyze;

    if(name === 'queueName' || name === 'membername') {
      const checkValueIsNumber = isTripleChar(value);
      changeScreen(checkValueIsNumber, name);
      return checkValueIsNumber;
    };

    if(name === 'penalty'|| name === 'paused') {
      const checkValueIsCharacters = checkNumber(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    setValues((prevState) => prevState, values[name] = value);

    if(Object.keys(validate).length >= 4) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataMemberUpdate = async () => {
    const sendDataUpdate = await exportUpdateQueueMember(values);
    
    if (sendDataUpdate) history.push('/config/fila/membros/lista');
    return;
  };

  useEffect(() => {
    validateUserLogged()
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              <strong className="is-size-3">ALTERAR MEMBRO DO GRUPO</strong>
              <hr className="dropdown-divider"/>
            </div>
          </div>
          <article id="alert-create-endpoints" name="alert-create-endpoints" className="column is-half is-offset-one-quarter message is-warning is-hidden">
            <div className="message-header">
              <p>Atenção!</p>
              <button className="delete" aria-label="delete" onClick={ () => toggleIsHidden('#alert-create-endpoints') }></button>
            </div>
            <div className="message-body">
              Membro do grupo alterado com sucesso!
            </div>
          </article>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
              Ramal: <strong className="is-size-5">{ values.endpoint }</strong>
            </div>
          </div>
          <form name="create-form" id="create-form" onSubmit={ (e) =>  e.preventDefault() }>
            <div className="columns mx-2">
              <div className="field column is-offset-1 is-3">
                <label className="label">Fila
                  <div className="control">
                    <div name="queueName" className="select is-fullwidth">
                      <select className="select" name="queueName" defaultValue={ values['queueName']} onChange={(e) => handleChangeValues(e.target)} >
                        <option value="">Selecione</option>
                        { queues.map((queue) => <option key={ queue } value={ queue }> { queue } </option>) }
                      </select>
                    </div>
                    <p name="queueName-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                  </div>
                </label>
              </div>
              <div className="column is-3 field">
                <label className="label">Nome do Atendente/Membro
                  <div className="control">
                  <input className="input" name="membername" type="text" defaultValue={ values['membername'] } onChange={(e) => handleChangeValues(e.target)} />
                  <p name="membername-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                  </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Penalidade
                  <div className="control">
                  <input className="input" name="penalty" defaultValue={ values['penalty']} type="text" onChange={(e) => handleChangeValues(e.target)} />
                  <p name="penalty-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                </div>
                </label>
              </div>
              <div className="column is-2 field">
                <label className="label">Pausa
                  <div className="control">
                    <div name="paused" className="select is-fullwidth">
                      <select className="select" name="paused" defaultValue={ values['paused']} onChange={(e) => handleChangeValues(e.target)} >
                        <option value="">Selecione</option>
                        <option value="1">Sim</option>
                        <option value="0">Não</option>
                      </select>
                    </div>
                    <p name="paused-invalid-data" className='has-text-danger is-size-7 is-hidden'>Caracteres inválidos!</p>
                  </div>
                </label>
              </div>
            </div>
          </form>
          <div className="columns">
            <div className="column is-half is-offset-one-quarter has-text-centered">
                <button className="button is-info is-half mx-3 px-6" type="submit" onClick={ () => sendDataMemberUpdate() } disabled={ disable }>
                      <span className="icon">
                        <FontAwesomeIcon icon={ faSave } fixedWidth />
                      </span>
                      <span>
                        Atualizar
                      </span>
                </button>
            </div>
          </div>
        </div>
      }
    </div>
  );
}

export default MemberQueuesById;
